import { render, staticRenderFns } from "./sponsor-select.vue?vue&type=template&id=f98b92be&"
import script from "./sponsor-select.vue?vue&type=script&lang=js&"
export * from "./sponsor-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports